const id_trans_production = {
    "": "proses produksi",
    goods: "proses barang",
    add: "tambah proses produksi",
    edit: "ubah proses produksi",
    from_whs: "dari gudang",
    to_whs: "ke gudang",

    label: {
        process_result: "HASIL PROSES",
        process_remaing: "Sisa Proses",
        process_start: "mulai proses",
        raw_material: "BAHAN BAKU",
        sign_by: "ditanda tangani oleh",

        process_qty: "jumlah produksi",
        process_clear: "bersihkan proses",
        process_add: "tambah proses",
        process_save_process: "simpan dan proses",

        title_raw_material: "bahan baku per produksi",
        title_process_result: "hasil proses per produksi",
    }
}

export default id_trans_production;